import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import confetti from "canvas-confetti";
import { NbButton } from "@/components/nb";

// Fires a colourful burst of confetti — 3 quick shots for extra oomph.
export function celebrate() {
  const colors = ["#B4F8C8", "#FFAEBC", "#FBE7C6", "#A0E7E5", "#0A0A0A"];
  const shots = [
    { angle: 60,  spread: 55, origin: { x: 0, y: 0.9 } },
    { angle: 120, spread: 55, origin: { x: 1, y: 0.9 } },
    { angle: 90,  spread: 70, origin: { x: 0.5, y: 0.4 } },
  ];
  shots.forEach((s, i) => {
    setTimeout(() => {
      confetti({
        ...s,
        particleCount: 90,
        startVelocity: 45,
        colors,
        gravity: 0.9,
        scalar: 1.1,
      });
    }, i * 180);
  });
}

// Modal shown when a streak milestone (spark / wildfire / fortnight flame / legend) unlocks.
export default function MilestoneUnlockModal({ milestone, onClose }) {
  useEffect(() => {
    if (milestone) celebrate();
  }, [milestone?.id]);

  return (
    <AnimatePresence>
      {milestone && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] grid place-items-center bg-black/50 p-5"
          onClick={onClose}
          data-testid="milestone-modal"
        >
          <motion.div
            initial={{ opacity: 0, y: 40, scale: 0.85, rotate: -6 }}
            animate={{ opacity: 1, y: 0, scale: 1, rotate: 0 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ type: "spring", stiffness: 220, damping: 18 }}
            onClick={(e) => e.stopPropagation()}
            className={`relative max-w-md w-full bg-white nb-border nb-shadow-xl rounded-2xl overflow-hidden`}
            data-testid={`milestone-${milestone.id}`}
          >
            <div className={`bg-sl-${milestone.color} p-6 text-center border-b-2 border-black`}>
              <div className="font-mono-sl text-[10px] uppercase tracking-widest">BADGE UNLOCKED</div>
              <motion.div
                animate={{ scale: [1, 1.25, 1], rotate: [0, -8, 8, 0] }}
                transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
                className="text-7xl mt-1"
              >
                {milestone.emoji}
              </motion.div>
              <div className="font-heading font-black text-4xl tracking-tighter mt-1">{milestone.name}</div>
              <div className="font-mono-sl text-xs uppercase mt-1">{milestone.days}-day streak</div>
            </div>
            <div className="p-5">
              <p className="text-neutral-800">{milestone.message}</p>
              <div className="mt-4 flex justify-end">
                <NbButton onClick={onClose} color="black" data-testid="milestone-close">Keep going</NbButton>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
